<template>
  <div>
    <Head title="Aloca curs" />
    <h1 class="text-2xl font-bold mb-4">
      <Link
        class="text-indigo-500 hover:text-indigo-600"
        :href="$routes.user(user.id)"
      >
        {{ user.first_name + ' ' + user.last_name }}
        / </Link
      >Aloca curs
    </h1>
    <user-course-form
      v-model="form"
      :available-courses="availableCourses"
      class="max-w-3xl bg-white w-xl"
      @submit="submit"
    >
      <div
        class="flex items-center justify-end border-t border-gray-200 bg-gray-100 px-8 py-4"
      >
        <loading-button
          :disabled="Object.keys(form.user_course).length == 0"
          :loading="form.processing"
          class="btn-teal"
          type="submit"
        >
          Aloca curs
        </loading-button>
      </div>
    </user-course-form>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';
import LoadingButton from '@/Shared/LoadingButton.vue';
import UserCourseForm from './Form.vue';
import { toDateString, toTimeString } from '@/utils/formatters';

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    UserCourseForm,
  },
  layout: Layout,
  props: {
    user: {
      type: Object,
      required: true,
    },
    availableCourses: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        user_course: {},
      }),
    };
  },
  methods: {
    toDateString,
    toTimeString,
    submit() {
      this.form
        .transform((data) => ({
          ...data,
          user_course: {
            ...data.user_course,
            reschedule_reason: data.user_course.reschedule_reason || '',
            rescheduled: !!data.user_course.rescheduled,
            finish_status: data.user_course.finish_status || null,
            start_date: this.toDateString(data.user_course.start_date),
            end_date: this.toDateString(data.user_course.end_date),
            presentation_date: this.toDateString(
              data.user_course.presentation_date,
            ),
            presentation_start_time: this.toTimeString(
              data.user_course.presentation_start_time,
            ),
            presentation_end_time: this.toTimeString(
              data.user_course.presentation_end_time,
            ),
            project_date: this.toDateString(data.user_course.project_date),
            date_reschedule_requested: this.toDateString(
              data.user_course.date_reschedule_requested,
            ),
            restart_start_date: this.toDateString(
              data.user_course.restart_start_date,
            ),
            restart_end_date: this.toDateString(
              data.user_course.restart_end_date,
            ),
          },
        }))
        .post(this.$routes.user_user_courses(this.user.id));
    },
  },
};
</script>
